import Pagination from "../../../../../../components/Pagination";
import {
  TR,
  TH,
  TD,
  TableHead,
  TableBody,
  Table,
  TableContainer,
  EmptyState,
  TotalMembers,
  Empty,
  IconLink,
  EmailWrapper,
  EmailText,
  ContactActions,
  NameCell,
  TotalCell,
  DateText,
  CountText,
  EmailGlobalStyles
} from "../../../../components/MembersList/styles";
import { MembershipState, LeadMagnetTag } from "./styles";

import services from "../../../../../../services";
import { useDispatch } from "react-redux";
import Button from "../../../../../../components/Button";
import moment from "moment";
import { useMemo } from "react";
import CopyToClipboad from "../../../../../../components/CopyToClipboad";
import constants from "../../../../../../constants";
import Image from "../../../../../../components/Image";
import { formatPrice } from "../../../../../../helpers/price-formatter";
import { Center } from "../../../../../../components/StyledComponents";

import Icon from '../../../../../../components/Icon'
import TelegramIcon from "../../../../../../assets/icons/telegram.svg";
import WhatsappIcon from "../../../../../../assets/icons/whatsapp.svg";
import EmailIcon from "../../../../../../assets/icons/mail.svg";
import SortAscIcon from "../../../../../../assets/icons/sort_ascending.svg";
import SortDescIcon from "../../../../../../assets/icons/sort_decending.svg";
import { useWindowSize } from "../../../../../../hooks/useWindowSize";

const Label = ({ countryCode, showCountryCode }) => {
  const country = constants?.countries?.find((c) => c.code === countryCode);
  return country ? (
    <>
      <Image src={country?.flag} width="20px" height="15px" alt="" />
      {showCountryCode && country?.code}
    </>
  ) : null;
};

const emptyState = (numrows = 8) => {
  return Array.from({ length: numrows }, (_, i) => (
    <TR key={`empty-row-${i}`}>
      <TD className="sticky-left"><Empty /></TD>
      <TD><Empty /></TD>
      <TD><Empty /></TD>
      <TD><Empty /></TD>
      <TD><Empty /></TD>
      <TD><Empty /></TD>
      <TD className="sticky-right"><Empty /></TD>
    </TR>
  ));
};

interface Filter {
  [field: string]: (string | number)[];
}

interface DataType {
  subscriber_id: number;
  country: string;
  name: string;
  last_name: string;
  currency: string
  email: string;
  total_investment: number;
  free_experiences_count: number;
  experiences_count: number;
  total_subscriptions_count: string;
  recurring_subscription: {
    id: number;
    status: string;
    started_at?: string;
    next_billing_at?: string;
    cancelled_at?: string;
    expire_at?: string
  } | null;
  phone_number?: string;
  lead_magnets?: Array<{
    id: number;
    title: string;
    group_id: number;
  }>;
}

interface ComponentProps {
  groupId?: number;
  states: {
    loading: boolean;
    success: boolean;
    error: boolean | string;
  };
  data: DataType[];
  filters: Filter[];
  pagination: {
    currentPage: number;
    from: number;
    lastPage: number;
    perPage: number;
    to: number;
    total: number;
  };
  goToPage: (page: number) => void;
  sortBy?: string;
  sortDirection?: "asc" | "desc";
  onSort?: (dataIndex: string) => void;
}

const Component = ({
  groupId,
  states,
  data,
  filters,
  pagination,
  goToPage,
  sortBy,
  sortDirection = "asc",
  onSort,
}: ComponentProps) => {
  const { isMobile } = useWindowSize();
  const dispatch = useDispatch();

  const getTotalMembersText = (number) => `${number} ${number > 1 ? "miembros" : "miembro"}`;

  const paginate = (page) => goToPage?.(page);

  const exportSubscribers = () => {
    if (groupId) {
      services?.group?.exportSubscribers(groupId, filters);
    }
  };

  const EmailCell = ({ email }) => {
    if (!email) return null;

    return (
      <div style={{
        display: 'block',
        width: '100%',
        position: 'relative'
      }}>
        <CopyToClipboad
          copy={email}
          showChildren
          className="email-copy"
          style={{
            width: '100%',
            height: 'auto',
            display: 'block'
          }}
          successStyle={{
            position: "fixed",
            top: "20px",
            right: "20px",
            whiteSpace: "nowrap",
            fontSize: "12px",
            backgroundColor: "#333",
            color: "white",
            padding: "6px 12px",
            borderRadius: "6px",
            zIndex: 99,
            boxShadow: "0 4px 12px rgba(0, 0, 0, 0.3)"
          }}
        >
          <EmailWrapper className="email-wrapper" style={{
            display: 'block',
            width: '100%',
            textAlign: 'left'
          }}>
            <EmailText className="email-text" title={`Click para copiar: ${email}`} style={{
              display: 'block',
              width: '100%',
              textAlign: 'left'
            }}>
              {email}
            </EmailText>
          </EmailWrapper>
        </CopyToClipboad>
      </div>
    );
  };

  const Actions = ({ record }) => {
    return (
      <ContactActions>
        {record?.phone_number ? (
          <IconLink
            href={`https://t.me/${record?.phone_number}`}
            target="_blank"
            title="Enviar mensaje por Telegram"
          >
            <Icon icon={TelegramIcon} size="18px" color="#0088cc" />
          </IconLink>
        ) : (
          <IconLink className="disabled" title="Número no disponible">
            <Icon icon={TelegramIcon} size="18px" color="#DADADA" />
          </IconLink>
        )}

        {record?.phone_number ? (
          <IconLink
            href={`https://wa.me/${record?.phone_number}`}
            target="_blank"
            title="Enviar mensaje por WhatsApp"
          >
            <Icon icon={WhatsappIcon} size="18px" color="#25D366" />
          </IconLink>
        ) : (
          <IconLink className="disabled" title="Número no disponible">
            <Icon icon={WhatsappIcon} size="18px" color="#DADADA" />
          </IconLink>
        )}

        <CopyToClipboad
          copy={record?.email}
          successStyle={{
            position: "fixed",
            top: "20px",
            right: "20px",
            whiteSpace: "nowrap",
            fontSize: "12px",
            backgroundColor: "#333",
            color: "white",
            padding: "6px 12px",
            borderRadius: "6px",
            zIndex: 99,
            boxShadow: "0 4px 12px rgba(0, 0, 0, 0.3)"
          }}
        >
          <IconLink
            style={{ cursor: 'pointer' }}
            title="Copiar email"
            onClick={(e) => e.preventDefault()}
          >
            <Icon icon={EmailIcon} size="18px" color="#6b5ce7" />
          </IconLink>
        </CopyToClipboad>
      </ContactActions>
    );
  };

  const Sort = ({ dataIndex, children }) => {
    return (
      <Center horizontal="left" vertical="top">
        <button
          onClick={() => onSort?.(dataIndex)}
          style={{
            background: 'none',
            border: 'none',
            cursor: 'pointer',
            padding: '4px',
            display: 'flex',
            alignItems: 'center',
            gap: '4px'
          }}
        >
          {sortBy === dataIndex ? (
            <>
              {sortDirection === "asc" ? (
                <Icon icon={SortAscIcon} size="20px" color="#626768" />
              ) : (
                <Icon icon={SortDescIcon} size="20px" color="#626768" />
              )}
            </>
          ) : (
            <Icon icon={SortAscIcon} size="20px" color="#D0D0D0" />
          )}
        </button>
        {children}
      </Center>
    );
  };

  if (!states?.loading && data?.length <= 0) {
    return (
      <TableContainer>
        <Table>
          <TableHead>
            <TR>
              <TH className="sticky-left" style={{ width: '150px', minWidth: '150px', maxWidth: '150px' }}>Nombre</TH>
              <TH className="center" style={{ width: '60px', minWidth: '60px', maxWidth: '60px' }}>País</TH>
              <TH style={{ width: '250px', minWidth: '250px', maxWidth: '250px' }}>Info. de contacto</TH>
              <TH style={{ width: '200px', minWidth: '200px', maxWidth: '200px' }}>Lead Magnets</TH>
              <TH style={{ width: '105px', minWidth: '105px', maxWidth: '105px' }}>Talleres</TH>
              <TH style={{ width: '145px', minWidth: '145px', maxWidth: '145px' }}>Subscripción</TH>
              <TH className="sticky-right center" style={{ width: '100px', minWidth: '100px', maxWidth: '100px' }}>Contacto</TH>
            </TR>
          </TableHead>
        </Table>

        <EmptyState key="empty-state-community-member-list">
          {Object.values(filters)?.some(v => v.toString().trim().length > 0) ? `No hay resultados con los filtros aplicados` : `Aún no tienes miembros en la comunidad`}
        </EmptyState>
      </TableContainer>
    );
  }

  return (
    <>
      <EmailGlobalStyles />

      <TableContainer>
        <Table>
          <TableHead>
            <TR>
              <TH className={isMobile ? "" : "sticky-left"} style={{ width: isMobile ? '100px' : '150px' }}>
                Nombre
                {/* <Sort dataIndex="name">Nombre</Sort> */}
              </TH>
              <TH className="center" style={{ width: '60px' }}>
                País
                {/* <Sort dataIndex="country">País</Sort> */}
              </TH>
              <TH style={{ width: isMobile ? '150px' : '250px' }}>
                Info. de contacto
                {/* <Sort dataIndex="email">Email</Sort> */}
              </TH>
              <TH style={{ width: '200px' }}>
                Lead Magnets
              </TH>
              <TH style={{ width: '105px' }}>
                Talleres
                {/* <Sort dataIndex="experiences_count">Talleres</Sort> */}
              </TH>
              <TH style={{ width: '145px' }}>
                Subscripción
              </TH>
              <TH className={isMobile ? "" : "sticky-right center"} style={{ width: '100px' }}>
                Contacto
              </TH>
            </TR>
          </TableHead>

          <TableBody>
            {states?.loading ? (
              emptyState()
            ) : (
              data?.map((item, index) => {
                const memership = item?.recurring_subscription;
                const date = {
                  active: memership?.started_at
                    ? `Desde el ${moment
                      .unix(Number(memership?.started_at))
                      .format("DD/MM/YY")}`
                    : "",
                  paid: memership?.started_at
                    ? `Desde el ${moment
                      .unix(Number(memership?.started_at))
                      .format("DD/MM/YY")}`
                    : "Activa",
                  waiting_for_gateway: memership?.started_at
                    ? `Desde el ${moment
                      .unix(Number(memership?.started_at))
                      .format("DD/MM/YY")}`
                    : "Activa",
                  renewal_retrying: memership?.started_at
                    ? `Desde el ${moment
                      .unix(Number(memership?.started_at))
                      .format("DD/MM/YY")}`
                    : "Activa",
                  retrying: memership?.started_at
                    ? `Desde el ${moment
                      .unix(Number(memership?.started_at))
                      .format("DD/MM/YY")}`
                    : "Activa",


                  non_renewing: `Vence el ${moment(memership?.next_billing_at).format(
                    "DD/MM/YY"
                  )}`,


                  paused: memership?.started_at
                    ? `Pausada desde ${moment
                      .unix(Number(memership?.started_at))
                      .format("DD/MM/YY")}`
                    : "Pausada",


                  refunded: memership?.started_at
                    ? `Reintegrado el ${moment
                      .unix(Number(memership?.started_at))
                      .format("DD/MM/YY")}`
                    : "Reintegrado",
                  cancelled: memership?.cancelled_at
                    ? `De baja el ${moment
                      .unix(Number(memership?.cancelled_at))
                      .format("DD/MM/YY")}`
                    : "Cancelada",
                  not_paid: memership?.cancelled_at
                    ? `De baja el ${moment
                      .unix(Number(memership?.cancelled_at))
                      .format("DD/MM/YY")}`
                    : "Cancelada",


                  expired: memership?.expire_at
                    ? `Invitación Expirada el ${moment
                      .unix(Number(memership?.expire_at))
                      .format("DD/MM/YY")}`
                    : "Expirada",
                  pending_invite: `Invitado Pendiente`,


                  defaulted: memership?.cancelled_at
                    ? `Baja forzada desde el ${moment
                      .unix(Number(memership?.cancelled_at))
                      .format("DD/MM/YY")}`
                    : "",
                };

                return (
                  <TR key={`community-member-${item?.subscriber_id}-${index}`}>
                    <TD className={isMobile ? "" : "sticky-left"}>
                      <NameCell>
                        <div className="name">{item?.name || "-"}</div>
                        {item?.last_name && (
                          <div className="last-name">{item?.last_name}</div>
                        )}
                      </NameCell>
                    </TD>

                    <TD className="center">
                      {!!item?.country && <Label countryCode={item?.country} showCountryCode={false} />}
                    </TD>

                    <TD className="email-cell">
                      {!!item?.email && <EmailCell email={item?.email} />}
                    </TD>

                    <TD>
                      {item?.lead_magnets && item?.lead_magnets.length > 0 ? (
                        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '4px' }}>
                          {item.lead_magnets.map((lm, idx) => (
                            <LeadMagnetTag key={lm.id} title={lm.title}>
                              {lm.title}
                            </LeadMagnetTag>
                          ))}
                        </div>
                      ) : (
                        <span style={{ color: '#999', fontSize: '12px' }}>Sin lead magnets</span>
                      )}
                    </TD>


                    <TD>
                      <CountText>
                        {item?.experiences_count || 0}
                        {item?.experiences_count === 1 ? ' tomado' : ' tomados'}
                      </CountText>
                    </TD>

                    <TD>
                      <MembershipState
                        className={!!memership ? memership?.status : "no-subscribed"}
                      >
                        {console.log(memership)}
                        {console.log(item?.name)}
                        {!!memership ? date[memership?.status] : "No suscripto"}
                      </MembershipState>
                    </TD>

                    <TD className={isMobile ? "" : "sticky-right"}>
                      <Actions record={item} />
                    </TD>
                  </TR>
                );
              })
            )}
          </TableBody>
        </Table>
      </TableContainer>

      {pagination?.total > 0 && (
        <div style={{ marginTop: "20px" }}>
          <Pagination
            states={states}
            key="community-subscriptions-pagination"
            total={pagination?.total}
            from={pagination?.from}
            to={pagination?.to}
            currentPage={pagination?.currentPage}
            lastPage={pagination?.lastPage}
            onClick={paginate}
          />
        </div>
      )}
    </>
  );
};

export default Component;
